var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandName2Gray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 17.4",
    style: {
      enableBackground: "new 0 0 106 17.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4E75;}\n\t.st1{fill:#3DB12B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,17.1h-4.2L12.3,6.4L9.4,17.1H5.3l-5-15.8h4.3l2.9,10.6l2.9-10.6h4l2.9,10.6l2.9-10.6h4.3L19.4,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.2,5.2c3.5,0,5.9,2.4,5.9,5.9c0,0.4,0,0.8-0.1,1.2h-8c0.3,1.2,1.5,2,3,2c0.9,0,2-0.3,3.2-0.9l1.2,2.8 c-1.8,0.8-3.5,1.2-5,1.2c-4,0-6.7-2.5-6.7-6.1C23.9,7.7,26.5,5.2,30.2,5.2z M28.1,9.9h4.1c-0.1-1-0.9-1.7-1.9-1.7 C29.1,8.2,28.3,8.9,28.1,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,13.2c0,0.6,0.4,0.9,0.9,0.9c0.3,0,0.6,0,1-0.1l0.4,3.1c-0.8,0.2-1.7,0.3-2.4,0.3c-2.5,0-4-1.5-4-3.8V0.5 h4.1V13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.4,13.2c0,0.6,0.4,0.9,0.9,0.9c0.3,0,0.6,0,1-0.1l0.4,3.1c-0.8,0.2-1.7,0.3-2.4,0.3c-2.5,0-4-1.5-4-3.8V0.5 h4.1V13.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,17.1h-4.2L63.8,6.4L61,17.1h-4.2l-5-15.8h4.3L59,11.9l2.9-10.6h4l2.9,10.6l2.9-10.6H76L70.9,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.2,0c1.4,0,2.4,1,2.4,2.4s-1,2.4-2.4,2.4s-2.4-1-2.4-2.4C76.9,1,77.9,0,79.2,0z M77.2,5.4h4.1V17h-4.1V5.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.2,5.2c1.5,0,3,0.3,4.6,0.8l-0.9,2.9c-1.2-0.4-2.4-0.8-3.4-0.8c-0.7,0-1.2,0.3-1.2,0.7c0,1.4,5.8,0,5.8,4.6 c0,2.2-2,3.9-5,3.9c-1.6,0-3.2-0.3-5-0.9l0.9-2.9c1.4,0.6,2.6,0.8,3.7,0.8c0.8,0,1.2-0.3,1.2-0.8c0-1.5-5.8-0.1-5.8-4.6 C83.3,6.8,85.3,5.2,88.2,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,5.2c3.5,0,5.9,2.4,5.9,5.9c0,0.4,0,0.8-0.1,1.2h-8c0.3,1.2,1.5,2,3,2c0.9,0,2-0.3,3.2-0.9l1.2,2.8 c-1.8,0.8-3.5,1.2-5,1.2c-4,0-6.7-2.5-6.7-6.1C94.4,7.7,97,5.2,100.7,5.2z M98.5,9.9h4.1c-0.1-1-0.9-1.7-1.9-1.7 C99.6,8.2,98.8,8.9,98.5,9.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandName2Gray);
export default __webpack_public_path__ + "static/media/BrandName2Gray.f042004aada4f380967143927d155f50.svg";
export { ForwardRef as ReactComponent };